<template>
  <div id="breadcrumb">
    <div :class="currentStep >= index ? 'active': 'inactive'"
         :style="`color: ${corPrimaria}`"
         v-for="(template, index) in itensBreadcrumb" :key="index">
      <div v-if="template.name">
        <span>{{template.name}}</span>
        <i class="el-icon-arrow-right separator"></i>
      </div>
      <div :class="currentStep >= index ? 'progress-line': ''"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'bread-crumb-steps',
  props: {
    itensBreadcrumb: {}
  },
  computed: {
    ...mapState('BreadCrumbsStore', ['currentStep']),
    ...mapGetters('SetupApp', ['estilo']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    corSecundaria () {
      return this.estilo.aplicacao.corSecundariaAplicacao
    }
  }
}
</script>
<style lang="less">
#breadcrumb {
  padding: 12px 20px;
  display: flex;
  border-bottom: 1px solid #eeeeee;
.active {
  opacity: 1;
}

.inactive {
  opacity: 0.5;
}

.el-breadcrumb__inner {
  color: unset;
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: unset;
}

.el-breadcrumb__separator {
  color: unset;
}
.progress-line {
  border-bottom: 2px solid #E8AA27;
  position: relative;
  top: 13px;
}
.separator {
  padding: 4px;
}
}
</style>
